import { Badge, Table, HStack, Icon, Text } from "@chakra-ui/react";
import { Level } from "../../../../services/Dtos";
import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import { FaCog, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import useThemeColors from "../../../../hooks/useThemeColors";
import CustomButton from "../../../CustomUi/CustomButton";
import SettingsCard from "../../../CustomUi/SettingsCard";

interface Props {
  level: Level;
  handleClick: () => void;
  onPromotionRuleClick: (level: Level) => void;
  hasPromotionRule?: boolean;
  loadingPromotionRules?: boolean;
}

export default function LevelCard({
  level,
  handleClick,
  onPromotionRuleClick,
  hasPromotionRule = false,
  loadingPromotionRules = false,
}: Props) {
  const { users, accentColor } = useSchoolsContext();
  const colors = useThemeColors();
  let user = users.find((u) => u.id === level.adminId);

  return (
    <SettingsCard handleClick={handleClick} minW={"270px"}>
      <Table.Root fontSize={"sm"} variant={"outline"}>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Level Name</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              <Badge variant={"outline"} colorPalette={accentColor} size={"md"}>
                {level.levelName}
              </Badge>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Next Term Fees</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {level.nextTermFee || 0}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Level Admin</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {user ? `${user?.firstName} ${user?.lastName}` : "NOT SET"}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Order</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {level.order}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Promotion Rule</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              <HStack gap={2} justify="flex-end">
                {loadingPromotionRules ? (
                  <Badge colorPalette="gray" variant="subtle" fontSize="xs">
                    <HStack gap={1}>
                      <Icon as={FaCog} size={"sm"} />
                      <Text>Loading...</Text>
                    </HStack>
                  </Badge>
                ) : (
                  <Badge
                    colorPalette={hasPromotionRule ? "green" : "orange"}
                    variant="subtle"
                    fontSize="xs"
                  >
                    <HStack gap={1}>
                      <Icon
                        as={
                          hasPromotionRule
                            ? FaCheckCircle
                            : FaExclamationTriangle
                        }
                        size={"xs"}
                      />
                      <Text>{hasPromotionRule ? "Configured" : "Not Set"}</Text>
                    </HStack>
                  </Badge>
                )}
                <CustomButton
                  size="2xs"
                  variant="outline"
                  colorPalette={colors.schoolAccent.primary}
                  label={hasPromotionRule ? "Edit" : "Configure"}
                  icon={FaCog}
                  onClick={(e) => {
                    e.stopPropagation();
                    onPromotionRuleClick(level);
                  }}
                />
              </HStack>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </SettingsCard>
  );
}
